module.exports = __webpack_public_path__ + "img/documents.a6b3e520.svg";